// extracted by mini-css-extract-plugin
export default {"badge":"IdBadge_badge__HKMa7","small":"IdBadge_small__KfFYR","medium":"IdBadge_medium__VRo2I"};